import { COLLECTIONS, store } from './shared';

const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

const normalizeCreatePayload = payload => ({
  ...payload,
  label: (payload && (payload.label || payload.titulo)) || '',
  titulo: (payload && (payload.titulo || payload.label)) || '',
  sessao: (payload && (payload.sessao || payload.alias)) || '',
  alias: (payload && (payload.alias || payload.sessao)) || '',
  questoes: payload && Array.isArray(payload.questoes) ? payload.questoes : []
});

const mergeUpdatePayload = (current, payload) => {
  const merged = {
    ...current,
    ...payload
  };

  if (hasOwn(payload, 'questoes')) {
    merged.questoes = Array.isArray(payload.questoes) ? payload.questoes : [];
  } else {
    merged.questoes = Array.isArray(current && current.questoes) ? current.questoes : [];
  }

  return merged;
};

const update = async (id, payload) => {
  const currentResult = await store.getById(COLLECTIONS.secoes, id);

  if (!currentResult.ok || !currentResult.data) {
    return currentResult;
  }

  const nextPayload = mergeUpdatePayload(currentResult.data, payload || {});
  return store.update(COLLECTIONS.secoes, id, nextPayload);
};

const secoesRepo = {
  list: async () => {
    const result = await store.list(COLLECTIONS.secoes);

    if (!result.ok) {
      return result;
    }

    const items = Array.isArray(result.data) ? result.data.map(normalizeCreatePayload) : [];
    return { ok: true, data: items, error: null };
  },
  getById: async id => store.getById(COLLECTIONS.secoes, id),
  create: async payload => store.create(COLLECTIONS.secoes, normalizeCreatePayload(payload)),
  update,
  remove: async id => store.remove(COLLECTIONS.secoes, id)
};

export default secoesRepo;
